import styled from 'styled-components';
import { theme } from 'src/styles/theme';

const Button = styled.button`
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  background-color: #212a31;
  color: white;
  border: none;
  background-image: none;
  box-shadow: none;
  cursor: pointer;
  text-transform: uppercase;
  padding: 15px 73px;
  margin-left: auto;

  opacity: 0.9;
  transition: 0.2s;

  &:hover {
    opacity: 1;
  }

  &:disabled,
  &[disabled] {
    pointer-events: none;
    opacity: 0.6;
  }

  &.estimate {
    background-color: ${theme.colors.primary};
    color: white;
  }

  @media ${theme.device.laptop} {
    width: 100%;
    margin: 0 auto;

    max-width: 260px;
    padding: 15px 30px;
    z-index: ${theme.index.middle};
    opacity: 1;

    &.domain {
      max-width: 150px;
      margin: 0;
    }

    &.close {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
    }
  }
`;

export default Button;
